/**
 * ROAR-4802 (P1.11) — the new `platform_role`/`access_mode` vocabulary this Story introduces,
 * mirroring api-backend-provapt's own `platformRoles`/`accessModes` shape exactly (its
 * src/utils/constants.js) so the two stay trivially diffable. Deliberately separate from
 * `customerRoles.js`, which holds the OLD, being-retired pentest-module role vocabulary
 * (customer_leader/pentest_manager/point_of_contact) — mixing the two in one file would blur a
 * distinction the whole Story is built around.
 */
export const platformRoles = {
  SUPER_ADMIN: 'super_admin',
  MSSP_ADMIN: 'mssp_admin',
  MSSP_USER: 'mssp_user',
  CUSTOMER_ADMIN: 'customer_admin',
  CUSTOMER_USER: 'customer_user',
};

export const accessModes = {
  WRITE: 'write',
  READ: 'read',
};

const CUSTOMER_FAMILY = [platformRoles.CUSTOMER_ADMIN, platformRoles.CUSTOMER_USER];
const MSSP_FAMILY = [platformRoles.MSSP_ADMIN, platformRoles.MSSP_USER];

/**
 * ROAR-4970 (PR3, AC2/AC3) — mirrors the backend's `memberMutationGate.js` `familyFor` rule: a
 * role/access EDIT may only move a member within their own tier family, never across tiers.
 * Keyed off the row's own `platform_role` (the FE has no `user_type` field to key off, but the
 * two always pair up in practice — customer_admin/customer_user with customer rows, mssp_admin/
 * mssp_user with provider rows).
 *
 * @param {string} platformRole
 * @returns {string[]} the two roles in the same family, in a stable order
 */
export const getSameFamilyRoles = (platformRole) =>
  MSSP_FAMILY.includes(platformRole) ? [...MSSP_FAMILY] : [...CUSTOMER_FAMILY];
